<template>
  <div class="message-wrap" v-if="visible">
    <div class="box">
      <img v-if="type === 'success'" src="@/assets/images/right.png" alt="">
      <img v-if="type === 'error'" src="@/assets/images/wrong.png" alt="">
      <img v-if="type === 'warning'" src="@/assets/images/warning.png" alt="">
      <div class="message">{{content}}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Confirm',
  data() {
    return {
      visible: false,
      content: '',
      type: '',
    }
  },
  methods: {
    init() {
      this.visible = true;
      setTimeout(()=>{
        this.visible = false
      },1500)
    }
  }
}
</script>

<style lang="less" scoped>
.message-wrap {
  position: fixed;
  z-index: 11111;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  min-width: 280px;
  height: 200px;
  box-shadow: 0px 5px 20px 0px rgba(0, 0, 0, 0.2);
  box-sizing: border-box;
  background: #FFFFFF;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  padding: 0 30px;

  .box {
    display: flex;
    flex-direction: column;
    align-items: center;

    img {
      width: 60px;
    }

    .message {
      font-size: 16px;
      margin-top: 36px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/MessageBox/MessageBox.vue